const DELIMITER = ",";
export function geolocationToLatLng(geolocation?: string | null) {
  if (typeof geolocation !== "string") return null;

  const [lat, lng] = geolocation.split(DELIMITER);

  if (typeof lat !== "string" || typeof lng !== "string") return null;

  return {
    lat: Number.parseFloat(lat),
    lng: Number.parseFloat(lng),
  };
}

export function latLngToGeolocation({ lat, lng }: { lat: number; lng: number }) {
  return [lat, lng].join(DELIMITER);
}
